import { makeStyles, Theme } from "@material-ui/core/styles";
import { UserRole } from "modules/user/types/entities";

export const userRoleColorMap: Record<UserRole, string> = {
  administrator: "#6772e6",
  master: "#6772e6",
  staff: "#b05bdb",
  client: "#b05bdb",
  team_viewer: "#73bf7c",
  client_viewer: "#73bf7c",
  executive: "#55acee",
  program_manager: "#cb7531"
};

export const useUserDropdownStyles = makeStyles<Theme, { userRole: UserRole }>(
  theme => ({
    avatarBadge: {
      backgroundColor: ({ userRole }) => userRoleColorMap[userRole],
      color: ({ userRole }) => userRoleColorMap[userRole],
      boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
      "&::after": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        animation: "$ripple 1.2s infinite ease-in-out",
        border: "1px solid currentColor",
        content: '""'
      }
    },
    "@keyframes ripple": {
      "0%": {
        transform: "scale(.8)",
        opacity: 1
      },
      "100%": {
        transform: "scale(2.0)",
        opacity: 0
      }
    },

    avatar: {
      width: 42,
      height: 42,

      "&:hover": {
        backgroundColor: "#bdbdbd",
        border: `2px solid ${theme.palette.primary.light}`
      },
      "&:focus": {
        backgroundColor: "#bdbdbd",
        border: `2px solid ${theme.palette.primary.light}`
      }
    },

    paper: {
      minWidth: 180
    },

    menu: {
      padding: "15px 17px"
    },

    menuItem: {
      padding: "0 8px"
    },

    head: {
      opacity: "1 !important",
      padding: 0,
      paddingLeft: 10
    },

    chip: {
      textTransform: "capitalize",
      marginBottom: 6,
      backgroundColor: ({ userRole }) => userRoleColorMap[userRole]
    },

    itemIcon: {
      minWidth: "unset",
      marginRight: 14
    }
  })
);
